import md5 from 'md5';
import jsonp from 'jsonp';

export default {
  // 翻译成英文
  translateEn(text) {
    return new Promise((resolve, reject) => {
      text = text.replace(/[#&+]/g, '');// 去除特殊字符，这个丢进翻译会报错，所以翻译的时候去除
      const appid = '20190703000314245';
      const key = 'aonI7c46UZq5oHjLgBL7';
      const from = 'zh';
      const to = 'en';
      const salt = new Date().getTime();
      const query = text;
      const str1 = appid + query + salt + key;
      const sign = md5(str1);

      const url = `https://api.fanyi.baidu.com/api/trans/vip/translate?q=${
        query
      }&appid=${
        appid
      }&salt=${
        salt
      }&from=${
        from
      }&to=${
        to
      }&sign=${
        sign
      }`;
      jsonp(url, {}, (err, res) => {
        if (err) return reject(err);
        if (res && res.trans_result && res.trans_result[0] && res.trans_result[0].dst) {
          resolve(res.trans_result[0].dst);
        } else {
          reject();
        }
      });
    });

  },
};



// WEBPACK FOOTER //
// ./src/services/translate-service.js